/**
 * Splits and returns the value in format '1 000 000'
 * @param {number} value - Value for splitting
 *
 * @returns {string} r - Formatted string
 */

function thousandSplitter (value) {
  let r, i
  r = '' + value
  for (i = r.length - 3; i > 0; i -= 3) {
    r = r.substr(0, i) + '\u0020' + r.substr(i)
  }
  return r
}

export default thousandSplitter
